import React from 'react';

const StatsHeader = ({ battingKPI, battingStats, bowlingKPI }) => (

    <div className="statsHeader">
        <div className="mcContainer">
            <div className="col s12 m12 l12">
                <ul className="statsList no-margin">
                    <li>
                        <span>Matches </span>
                        <i className="ng-binding">{battingKPI.Matches}</i>
                    </li>

                    <li className="">
                        <span>Innings </span>
                        <i className="ng-binding">{battingKPI.Innings}</i>
                    </li>

                    <li>
                        <span>Runs </span>
                        <i className="ng-binding">{battingKPI.TotalRuns}</i>
                    </li>

                    <li className="">
                        <span>Wickets </span>
                        <i className="ng-binding">{battingKPI.WicketLost}</i>
                    </li>

                    <li className="">
                        <span>Balls </span>
                        <i className="ng-binding">{battingKPI.Balls}</i>
                    </li>

                    <li className="">
                        <span>Ones </span>
                        <i className="ng-binding">{battingKPI.Ones}</i>
                    </li>

                    <li className="">
                        <span>Twos </span>
                        <i className="ng-binding">{battingKPI.Twos}</i>
                    </li>

                    <li className="">
                        <span>Threes </span>
                        <i className="ng-binding">{battingKPI.Threes}</i>
                    </li>

                    <li>
                        <span>fours </span>
                        <i className="ng-binding">{battingKPI.Bdry4}</i>
                    </li>
                    <li>
                        <span>Sixes </span>
                        <i className="ng-binding">{battingKPI.Bdry6}</i>
                    </li>

                    <li>
                        <span>50's </span>
                        <i className="ng-binding">{battingStats.HalfCenturies}</i>
                    </li>

                    <li className="">
                        <span>100's </span>
                        <i className="ng-binding">{battingStats.Centuries}</i>
                    </li>

                    <li>
                        <span>50+ Partnership </span>
                        <i className="ng-binding">{battingStats.FiftyPartnership}</i>
                    </li>
                    <li className="">
                        <span>100+ Partnership </span>
                        <i className="ng-binding">{battingStats.HundredPartnership}</i>
                    </li>

                    <li>
                        <span>Maidens </span>
                        <i className="ng-binding">{bowlingKPI.Maidens}</i>
                    </li>
                    <li>
                        <span>Dot Balls </span>
                        <i className="ng-binding">{bowlingKPI.DotBalls}</i>
                    </li>
                    <li>
                        <span>Dot Ball % </span>
                        <i className="ng-binding">{battingKPI.DBPercent}</i>
                    </li>

                    <li className="">
                        <span>DB Freq. </span>
                        <i className="ng-binding">{battingKPI.DBFrequency}</i>
                    </li>

                    <li>
                        <span>Bdry Freq. </span>
                        <i className="ng-binding">{battingKPI.BdryFreq}</i>
                    </li>
                    <li>
                        <span>Boundary% </span>
                        <i className="ng-binding">{battingKPI.BdryPercent}</i>
                    </li>
                    <li>
                        <span>Extras </span>
                        <i className="ng-binding">{battingKPI.RunsThroughExtras}</i>
                    </li>
                    <li>
                        <span>Catches </span>
                        <i className="ng-binding">{battingKPI.Catches}</i>
                    </li>
                    <li>
                        <span>Stumpings </span>
                        <i className="ng-binding">{battingKPI.Stumpings}</i>
                    </li>
                </ul>
            </div>
        </div>
    </div>
)
export default StatsHeader;